// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileDoubleSide_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 14.6906V15.9996H8.444V14.6906H7.135V9.01465H5.947C5.69767 9.16132 5.441 9.28598 5.177 9.38865C4.913 9.49132 4.59033 9.57932 4.209 9.65265V10.6536H5.518V14.6906H4Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 10V22L0 22V2H16V4L13 4V20H22V10H24ZM11 20V4H2L2 20H11Z" class="svg-bg"/>
  <path d="M18 2 24 8 18 8V2ZM15.077 16.0002V15.0762C15.5243 14.6582 15.9313 14.2695 16.298 13.9102 16.672 13.5435 16.991 13.2025 17.255 12.8872 17.5263 12.5645 17.7353 12.2675 17.882 11.9962 18.036 11.7175 18.113 11.4535 18.113 11.2042 18.113 10.8595 18.025 10.5992 17.849 10.4232 17.673 10.2399 17.431 10.1482 17.123 10.1482 16.8663 10.1482 16.639 10.2215 16.441 10.3682 16.243 10.5075 16.056 10.6725 15.88 10.8632L15 9.99419C15.3447 9.62752 15.6967 9.35252 16.056 9.16919 16.4153 8.97852 16.8443 8.88319 17.343 8.88319 17.6877 8.88319 17.9993 8.93819 18.278 9.04819 18.564 9.15085 18.8097 9.30119 19.015 9.49919 19.2203 9.68985 19.378 9.92085 19.488 10.1922 19.598 10.4635 19.653 10.7679 19.653 11.1052 19.653 11.3985 19.5907 11.6992 19.466 12.0072 19.3413 12.3079 19.1727 12.6122 18.96 12.9202 18.7547 13.2209 18.5163 13.5252 18.245 13.8332 17.981 14.1339 17.706 14.4309 17.42 14.7242 17.596 14.7022 17.7903 14.6839 18.003 14.6692 18.223 14.6472 18.4173 14.6362 18.586 14.6362H19.994V16.0002H15.077Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileDoubleSide is a generated icon component.
 */
let IconFilesFileDoubleSide = IconFilesFileDoubleSide_1 = class IconFilesFileDoubleSide extends IconBaseElement {
    render() {
        return html `${IconFilesFileDoubleSide_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileDoubleSide.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconFilesFileDoubleSide = IconFilesFileDoubleSide_1 = __decorate([
    customElement('zui-icon-files-file-double-side')
], IconFilesFileDoubleSide);
export { IconFilesFileDoubleSide };
